import moment from 'moment-timezone';
import { HOPPLER_TIMEZONE } from '../../constants';

export class DateFormatter {
  withTimezone(dateString: string) {
    // DO NOT return a date if the input is null or undefined!
    // This will create data where there actually should be none.
    if (dateString === null || dateString === undefined) {
      return dateString;
    }

    return moment(dateString).tz(HOPPLER_TIMEZONE).format();
  }

  toNativeInputDateFormat(dateString: string) {
    // DO NOT return a date if the input is null or undefined!
    // This will create data where there actually should be none.
    if (dateString === null || dateString === undefined) {
      return dateString;
    }

    return moment(dateString).format('YYYY-MM-DD');
  }

  /**
   * We describe this format as "colloquial" as not all regions in the world use
   * the MM/DD/YY format, but we in the Philippines (almost) treat it as a default.
   * 
   * @param dateString 
   */
  asColloquialDate(dateString: string) {
    // DO NOT return a date if the input is null or undefined!
    // This will create data where there actually should be none.
    if (dateString === null || dateString === undefined) {
      return dateString;
    }

    return moment(dateString).format('MM/DD/YY');
  }
}

export const dateFormatter = new DateFormatter();
export const formatWithTimezone = (date) => dateFormatter.withTimezone(date);

/**
 * We describe this format as "colloquial" as not all regions in the world use
 * the MM/DD/YY format, but we in the Philippines (almost) treat it as a default.
 * @param date 
 */
export const formatAsColloquialDate = (date) => dateFormatter.asColloquialDate(date);
export const formatForNativeDateInput = (date) => dateFormatter.toNativeInputDateFormat(date);
